import { Search, X } from "lucide-react";
import "./OperationalDirectory.css";

type OperationalSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
};

export function OperationalSearchField({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: OperationalSearchFieldProps) {
  return (
    <div className="operational-search-field">
      <Search size={17} aria-hidden="true" />
      <input
        type="text"
        role="searchbox"
        aria-label={ariaLabel}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {value ? (
        <button
          type="button"
          aria-label="Limpar busca"
          onClick={() => onChange("")}
        >
          <X size={16} aria-hidden="true" />
        </button>
      ) : null}
    </div>
  );
}
